const errors = {
  en: [
    'Specific gravity field cannot be empty.',
    'Primary pressure field cannot be empty.',
    'Secondary pressure field cannot be empty.',
    'Flow rate field cannot be empty.',
    'Primary pressure must be higher than secondary pressure.',
    'Air temperature field cannot be empty.',
  ],
  nl: [
    'Specifiek zwaartekrachtveld kan niet leeg zijn.',
    'Primair drukveld mag niet leeg zijn.',
    'Secundair drukveld mag niet leeg zijn.',
    'Veld debiet mag niet leeg zijn.',
    'Primaire druk moet hoger zijn dan secundaire druk.',
    'Luchttemperatuurveld mag niet leeg zijn.',
  ],
  de: [
    'Das spezifische Gravitationsfeld darf nicht leer sein.',
    'Primärdruckfeld darf nicht leer sein.',
    'Sekundäres Druckfeld darf nicht leer sein.',
    'Durchflussfeld darf nicht leer sein.',
    'Primärdruck muss höher sein als Sekundärdruck.',
    'Lufttemperaturfeld darf nicht leer sein.',
  ],
  es: [
    'El campo de gravedad específico no puede estar vacío.',
    'El campo de presión principal no puede estar vacío.',
    'El campo de presión secundario no puede estar vacío.',
    'El campo de tasa de flujo no puede estar vacío.',
    'La presión primaria debe ser mayor que la presión secundaria.',
    'El campo de temperatura del aire no puede estar vacío.',
  ],
  fr: [
    'Le champ de gravité spécifique ne peut pas être vide.',
    'Le champ de pression primaire ne peut pas être vide.',
    'Le champ de pression secondaire ne peut pas être vide.',
    'Le champ de débit ne peut pas être vide.',
    'La pression primaire doit être supérieure à la pression secondaire.',
    "Le champ de température de l'air ne peut pas être vide.",
  ],
};

const { lang } = document.getElementsByTagName('html')[0];
const localizedErrors = errors[lang];

function ConvertToBarAbs(pressureValue, pressureUnit) {
  switch (pressureUnit) {
    // Absolute pressures
    case 'kpa_abs':
      return pressureValue * 0.01;
    case 'mpa_abs':
      return pressureValue * 10;
    case 'psi_abs':
      return pressureValue * 0.0689476;
    case 'bar_abs':
      return pressureValue * 1;
    case 'kgcm2_abs':
      return pressureValue * 0.980665;
    case 'mmhg_abs':
      return pressureValue * 0.0013332239;
    case 'inhg_abs':
      return pressureValue * 0.0338639;

    // Gauge pressures
    case 'kpa_g':
      return pressureValue * 0.01 + 1;
    case 'mpa_g':
      return pressureValue * 10 + 1;
    case 'psi_g':
      return pressureValue * 0.0689476 + 1;
    case 'bar_g':
      return pressureValue * 1 + 1;
    case 'kgcm2_g':
      return pressureValue * 0.980665 + 1;
    case 'mmhg_g':
      return pressureValue * 0.0013332239 + 1;
    case 'inhg_g':
      return pressureValue * 0.0338639 + 1;
    default:
      throw new Error(`Unknown pressure unit: ${pressureUnit}`);
  }
} // ConvertToBarAbs()

function ConvertToM3PerHour(flowValue, flowUnit) {
  switch (flowUnit) {
    case 'm3_h':
      return flowValue * 1;
    case 'm3_min':
      return flowValue * 60;
    case 'l_h':
      return flowValue * 0.001;
    case 'l_min':
      return flowValue * 0.001 * 60;
    case 'us_gal_h':
      return flowValue * 0.00378541178;
    case 'us_gal_min':
      return flowValue * 0.00378541178 * 60;
    case 'uk_gal_h':
      return flowValue * 0.00454609188;
    case 'uk_gal_min':
      return flowValue * 0.00454609188 * 60;
    default:
      throw new Error(`Unknown flow unit: ${flowUnit}`);
  }
} // ConvertToM3PerHour()

function ErrorOutput(errorText) {
  document.getElementById('error_box').innerHTML = errorText;
}

function Calculate() {
  // Quick input sanity check
  const specificGravity = document.getElementsByName('specific_gravity')[0].value;
  // Check that specific gravity is not empty

  if (specificGravity === '') {
    return ErrorOutput(localizedErrors[0]);
  }

  const inputPrimaryPressureValue = document.getElementsByName('primary_pressure')[0].value;
  const inputPrimaryPressureUnit = document.getElementById('primary_pressure_unit').value;
  // Check that primary pressure is not empty

  if (inputPrimaryPressureValue === '') {
    return ErrorOutput(localizedErrors[1]);
  }

  const primaryPressureBar = ConvertToBarAbs(inputPrimaryPressureValue, inputPrimaryPressureUnit);

  const inputSecondaryPressureValue = document.getElementsByName('secondary_pressure')[0].value;
  const inputSecondaryPressureUnit = document.getElementById('secondary_pressure_unit').value;
  // Check that secondary pressure is not empty

  if (inputSecondaryPressureValue === '') {
    return ErrorOutput(localizedErrors[2]);
  }

  const secondaryPressureBar = ConvertToBarAbs(inputSecondaryPressureValue, inputSecondaryPressureUnit);

  const inputFlowRateValue = document.getElementsByName('flow_rate')[0].value;
  const inputFlowRateUnit = document.getElementById('flow_rate_unit').value;
  // Check that flow rate is not empty

  if (inputFlowRateValue === '') {
    return ErrorOutput(localizedErrors[3]);
  }

  const flowRate = ConvertToM3PerHour(inputFlowRateValue, inputFlowRateUnit);

  const pressureDropBar = primaryPressureBar - secondaryPressureBar;

  if (pressureDropBar < 0) {
    return ErrorOutput(localizedErrors[4]);
  }

  const kvValue = flowRate * Math.sqrt(specificGravity / pressureDropBar);
  const cvValue = kvValue / 0.865;

  document.getElementsByName('kv_value')[0].value = kvValue.toFixed(4);
  document.getElementsByName('cv_value')[0].value = cvValue.toFixed(4);
  ErrorOutput(''); // Clear the error message if everything is ok
} // Calculate()

function liquidOnChange() {
  switch (document.getElementById('liquid')?.value) {
    case 'water':
      document.getElementsByName('specific_gravity')[0].value = '1.00';
      document.getElementsByName('specific_gravity')[0].disabled = 'disabled';
      break;
    case 'glycerine':
      document.getElementsByName('specific_gravity')[0].value = '1.26';
      document.getElementsByName('specific_gravity')[0].disabled = 'disabled';
      break;
    case 'gasoline':
      document.getElementsByName('specific_gravity')[0].value = '0.75';
      document.getElementsByName('specific_gravity')[0].disabled = 'disabled';
      break;
    case 'ethyl_alcohol':
      document.getElementsByName('specific_gravity')[0].value = '0.79';
      document.getElementsByName('specific_gravity')[0].disabled = 'disabled';
      break;
    case 'custom':
      document.getElementsByName('specific_gravity')[0].value = '1.00';
      document.getElementsByName('specific_gravity')[0].disabled = false;
      break;
    default:
      throw new Error(`Unknown liquid: ${document.getElementById('liquid')?.value}`);
  } // switch
} // liquidOnChange()

function ConvertToBarAbsGas(pressureValueGas, pressureUnitGas) {
  switch (pressureUnitGas) {
    // Absolute pressures
    case 'kpa_abs':
      return pressureValueGas * 0.01;
    case 'mpa_abs':
      return pressureValueGas * 10;
    case 'psi_abs':
      return pressureValueGas * 0.0689476;
    case 'bar_abs':
      return pressureValueGas * 1;
    case 'kgcm2_abs':
      return pressureValueGas * 0.980665;
    case 'mmhg_abs':
      return pressureValueGas * 0.0013332239;
    case 'inhg_abs':
      return pressureValueGas * 0.0338639;

    // Gauge pressures
    case 'kpa_g':
      return pressureValueGas * 0.01 + 1;
    case 'mpa_g':
      return pressureValueGas * 10 + 1;
    case 'psi_g':
      return pressureValueGas * 0.0689476 + 1;
    case 'bar_g':
      return pressureValueGas * 1 + 1;
    case 'kgcm2_g':
      return pressureValueGas * 0.980665 + 1;
    case 'mmhg_g':
      return pressureValueGas * 0.0013332239 + 1;
    case 'inhg_g':
      return pressureValueGas * 0.0338639 + 1;
    default:
      throw new Error(`Unknown pressure unit: ${pressureUnitGas}`);
  } // switch
} // ConvertToBarAbs()

function ConvertToM3PerHourGas(flowValueGas, flowUnitGas) {
  switch (flowUnitGas) {
    case 'm3_h':
      return flowValueGas * 1;
    case 'm3_min':
      return flowValueGas * 60;
    case 'l_h':
      return flowValueGas * 0.001;
    case 'l_min':
      return flowValueGas * 0.001 * 60;
    case 'us_gal_h':
      return flowValueGas * 0.00378541178;
    case 'us_gal_min':
      return flowValueGas * 0.00378541178 * 60;
    case 'uk_gal_h':
      return flowValueGas * 0.00454609188;
    case 'uk_gal_min':
      return flowValueGas * 0.00454609188 * 60;
    default:
      throw new Error(`Unknown flow unit: ${flowUnitGas}`);
  } // switch
} // ConvertToM3PerHour()

function ConvertToCDegresGas(airTemperatureValueGas, airTemperatureUnitGas) {
  switch (airTemperatureUnitGas) {
    case 'celsius':
      return airTemperatureValueGas * 1 + 273.15;
    case 'fahrenheit':
      return (airTemperatureValueGas - 32) / 1.8 + 273.15;
    case 'kelvin':
      return airTemperatureValueGas * 1;
    default:
      throw new Error(`Unknown air temperature unit: ${airTemperatureUnitGas}`);
  } // switch
} // ConvertToCDegres()

function ErrorOutputGas(errorTextGas) {
  document.getElementById('error_box_gas').innerHTML = errorTextGas;
}

function CalculateGas() {
  // Quick input sanity check
  const specificGravityGas = document.getElementsByName('specific_gravity_gas')[0].value;

  // Check that specific gravity is not empty
  if (specificGravityGas === '') {
    return ErrorOutputGas(localizedErrors[0]);
  }

  const inputAirTemperatureValueGas = document.getElementsByName('air_temperature_gas')[0].value;
  const inputAirTemperatureUnitGas = document.getElementById('air_temperature_unit_gas').value;

  // Check that air temperature is not empty
  if (inputAirTemperatureValueGas === '') {
    return ErrorOutputGas(localizedErrors[5]);
  }

  const airTemperatureCDegresGas = ConvertToCDegresGas(inputAirTemperatureValueGas, inputAirTemperatureUnitGas);

  const inputPrimaryPressureValueGas = document.getElementsByName('primary_pressure_gas')[0].value;
  const inputPrimaryPressureUnitGas = document.getElementById('primary_pressure_unit_gas').value;

  // Check that primary pressure is not empty
  if (inputPrimaryPressureValueGas === '') {
    return ErrorOutputGas(localizedErrors[1]);
  }

  const primaryPressureBarGas = ConvertToBarAbsGas(inputPrimaryPressureValueGas, inputPrimaryPressureUnitGas);

  const inputSecondaryPressureValueGas = document.getElementsByName('secondary_pressure_gas')[0].value;
  const inputSecondaryPressureUnitGas = document.getElementById('secondary_pressure_unit_gas').value;

  if (inputSecondaryPressureValueGas === '') {
    return ErrorOutputGas(localizedErrors[2]);
  }

  const secondaryPressureBarGas = ConvertToBarAbsGas(inputSecondaryPressureValueGas, inputSecondaryPressureUnitGas);

  const inputFlowRateValueGas = document.getElementsByName('flow_rate_gas')[0].value;
  const inputFlowRateUnitGas = document.getElementById('flow_rate_unit_gas').value;

  if (inputFlowRateValueGas === '') {
    return ErrorOutputGas(localizedErrors[3]);
  }

  const flowRateGas = ConvertToM3PerHourGas(inputFlowRateValueGas, inputFlowRateUnitGas);
  const pressureDropBarGas = primaryPressureBarGas - secondaryPressureBarGas;

  if (pressureDropBarGas < 0) {
    return ErrorOutputGas(localizedErrors[4]);
  }

  const airDensity = 1.225; // Density of air in kg/m³ at 20°C and 101.325 kPa

  let kvValueGas;

  if (secondaryPressureBarGas < primaryPressureBarGas / 2) {
    kvValueGas =
      (flowRateGas / (257 * primaryPressureBarGas)) *
      Math.sqrt(specificGravityGas * airDensity * airTemperatureCDegresGas);
  } else {
    kvValueGas =
      (flowRateGas / 514) *
      Math.sqrt(
        (specificGravityGas * airDensity * airTemperatureCDegresGas) /
          ((primaryPressureBarGas - secondaryPressureBarGas) * secondaryPressureBarGas)
      );
  }

  // var kv_value_gas = flow_rate * Math.sqrt(specific_gravity / pressure_drop_bar);
  const cvValueGas = kvValueGas / 0.865;

  document.getElementsByName('kv_value_gas')[0].value = kvValueGas.toFixed(4);
  document.getElementsByName('cv_value_gas')[0].value = cvValueGas.toFixed(4);
  ErrorOutputGas(''); // Clear the error message if everything is ok
} // Calculate()

function gasesOnChange() {
  switch (document.getElementById('gases').value) {
    case 'air':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.00';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'butane':
      document.getElementsByName('specific_gravity_gas')[0].value = '2.1142';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'carbondioxide':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.6163';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;

    case 'methane':
      document.getElementsByName('specific_gravity_gas')[0].value = '0.5878';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'nitrogen':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.0209';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'oxygen':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.1673';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'propane':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.6406';
      document.getElementsByName('specific_gravity_gas')[0].disabled = 'disabled';
      break;
    case 'custom':
      document.getElementsByName('specific_gravity_gas')[0].value = '1.00';
      document.getElementsByName('specific_gravity_gas')[0].disabled = false;
      break;
    default:
      throw new Error(`Unknown gas: ${document.getElementById('gases').value}`);
  } // switch
} // gasesOnChange()

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementsByClassName('calculator_form').length > 0) {
    const calculateFluidButtonElement = document.getElementById('calculate-fluid-button');

    if (calculateFluidButtonElement) {
      calculateFluidButtonElement.addEventListener('click', Calculate);
    }

    const calculateGasButtonElement = document.getElementById('calculate-gas-button');

    if (calculateGasButtonElement) {
      calculateGasButtonElement.addEventListener('click', CalculateGas);
    }

    const liquidElement = document.getElementById('liquid');

    if (liquidElement) {
      liquidElement.addEventListener('change', liquidOnChange);
    }

    const gasesElement = document.getElementById('gases');

    if (gasesElement) {
      gasesElement.addEventListener('change', gasesOnChange);
    }
  }
});
